export default "__VITE_ASSET__BRouVWse__"